import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isPageLoading: false
}


const loderSlice = createSlice({
    name: 'loader',
    initialState: initialState,
    reducers: {
        setPageLoader: (state, action) => {
            state.isPageLoading = action.payload
        }
    },
  
})

export const { setPageLoader } = loderSlice.actions;
export default loderSlice.reducer